import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { configurations } from '~/api/runtimeService';

type ConfigurationsVariables = {
  pipelineVersionId: string;
  realm: string;
  environment: string;
};

export const useConfigurations = () => {
  const queryClient = useQueryClient();

  const fetchConfigurations = useCallback(
    (variables: ConfigurationsVariables) =>
      queryClient.fetchQuery({
        queryKey: [
          'run',
          'configurations',
          variables.realm,
          variables.environment,
          variables.pipelineVersionId
        ],
        queryFn: async () => ({
          data: {
            configurations: await configurations({
              realm: variables.realm,
              pipelineId: variables.pipelineVersionId,
              environment: variables.environment
            })
          }
        }),
        staleTime: 0,
        gcTime: 0
      }),
    [queryClient]
  );

  return { fetchConfigurations };
};
